import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { Grid, Box, Button, CircularProgress } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useNavigate } from 'react-router-dom';
import LoginForm from './LoginForm';
const SignInSchema = Yup.object().shape({
	username: Yup.string().required('Username Required'),
	password: Yup.string().required('Password Required'),
});
const LoginFormNew = () => {
	const navigate = useNavigate();
	const [step, setStep] = useState('one');
	return (
		<Formik
			initialValues={{
				username: '',
				password: '',
				first_name: '',
				last_name: '',
				email: '',
				password1: '',
				confirm_password: '',
				pan_number: '',
				agency_name: '',
			}}
			validationSchema={SignInSchema}
			onSubmit={(values) => {
				console.log('signIn', values);
			}}>
			{(formik) => {
				const { errors } = formik;
				return (
					<Form
						style={{
							background: 'white',
							marginTop: 40,
							padding: 30,
							marginBottom: 40,
							borderRadius: 5,
							boxShadow: 'rgba(0, 0, 0, 0.4) 0px 1px 7px 0px',
						}}>
						<h1 style={{ textAlign: 'center', fontSize: 20 }}>
							Login with Musafir Bazar
						</h1>
						<Box
							mt={2}
							style={{
								display: 'flex',
								marginLeft: 30,
								marginRight: 30,
								border: '1px solid grey',
							}}>
							<Box
								onClick={() => setStep('one')}
								style={{
									background: step === 'one' ? 'rgb(51 65 127)' : '',
									textAlign: 'center',
									color: step === 'one' ? 'white' : 'black',
									width: '100%',
									padding: 10,
									cursor: 'pointer',
								}}>
								Login
							</Box>
							<Box
								onClick={() => setStep('two')}
								style={{
									width: '100%',
									padding: 10,
									textAlign: 'center',
									background: step === 'two' ? 'rgb(51 65 127)' : '',
									color: step === 'two' ? 'white' : 'black',
									cursor: 'pointer',
								}}>
								Register
							</Box>
						</Box>
						<Box
							style={{
								background: '#e6e7e8',
								padding: 20,
								marginTop: 20,
								border: '1px solid lightgrey',
								marginLeft: 30,
								marginRight: 30,
							}}>
							{step === 'one' ? (
								<Grid container>
									<Grid item xs={12}>
										<Field
											type='email'
											name='username'
											style={{
												width: '100%',
												padding: 10,
												border: errors.username
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
												marginTop: 10,
											}}
											placeholder='Enter your email or username'
											id='username '
										/>
										{errors.username ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.username}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} style={{ marginTop: 20 }}>
										<Field
											type='password'
											name='password'
											style={{
												width: '100%',
												padding: 10,
												border: errors.password
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
											}}
											placeholder='Enter your password'
											id='password'
										/>
										{errors.password ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.password}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} style={{ marginTop: 50 }}>
										{false ? (
											<Box style={{ textAlign: 'center' }}>
												<CircularProgress color='inherit' size={30} />
											</Box>
										) : (
											<Button
												type='submit'
												variant='contained'
												style={{
													color: 'white',
													background: 'orange',
													width: '100%',
												}}>
												Login
											</Button>
										)}
									</Grid>
								</Grid>
							) : (
								<Grid container>
									<Grid item xs={12}>
										<Field
											type='text'
											name='first_name'
											style={{
												width: '100%',
												padding: 10,
												border: errors.first_name
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
												marginTop: 10,
											}}
											placeholder='Enter your First Name'
											id='first_name '
										/>
										{errors.first_name ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.first_name}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} style={{ marginTop: 20 }}>
										<Field
											type='text'
											name='last_name'
											style={{
												width: '100%',
												padding: 10,
												border: errors.last_name
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
											}}
											placeholder='Enter your Last Name'
											id='last_name'
										/>
										{errors.last_name ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.last_name}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12}>
										<Field
											type='email'
											name='email'
											style={{
												width: '100%',
												padding: 10,
												border: errors.email
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
												marginTop: 10,
											}}
											placeholder='Enter your email'
											id='email '
										/>
										{errors.email ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.email}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} style={{ marginTop: 20 }}>
										<Field
											type='password'
											name='password1'
											style={{
												width: '100%',
												padding: 10,
												border: errors.password
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
											}}
											placeholder='Enter your password'
											id='password1'
										/>
										{errors.password1 ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.password1}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} style={{ marginTop: 20 }}>
										<Field
											type='password'
											name='confirm_password'
											style={{
												width: '100%',
												padding: 10,
												border: errors.confirm_password
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
											}}
											placeholder='Enter your Confirm password'
											id='confirm_password'
										/>
										{errors.confirm_password ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.confirm_password}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} style={{ marginTop: 20 }}>
										<Field
											type='text'
											name='pan_number'
											style={{
												width: '100%',
												padding: 10,
												border: errors.pan_number
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
											}}
											placeholder='Enter your Pan Number'
											id='pan_number'
										/>
										{errors.pan_number ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.pan_number}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} style={{ marginTop: 20 }}>
										<Field
											type='text'
											name='agency_name'
											style={{
												width: '100%',
												padding: 10,
												border: errors.agency_name
													? '2px solid red'
													: '1px solid grey',
												borderRadius: 5,
											}}
											placeholder='Enter your Agency Name'
											id='agency_name'
										/>
										{errors.agency_name ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.agency_name}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} style={{ marginTop: 50 }}>
										{false ? (
											<Box style={{ textAlign: 'center' }}>
												<CircularProgress color='inherit' size={30} />
											</Box>
										) : (
											<Button
												type='submit'
												variant='contained'
												style={{
													color: 'white',
													background: 'orange',
													width: '100%',
												}}>
												Register
											</Button>
										)}
									</Grid>
								</Grid>
							)}
							<Box
								mt={1}
								style={{
									display: 'flex',
									marginLeft: 30,
									marginBottom: 20,
									marginRight: 30,
									justifyContent: 'center',
								}}>
								<span>
									New User? <span style={{ color: 'red' }}>Create Account</span>
								</span>
							</Box>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default LoginFormNew;
